import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestitutionPrestation } from 'src/app/shared/models/restitutionPrestation';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class RestitutionPrestationService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllRestitutionPrestation(): Observable<RestitutionPrestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.restitutionPrestationUrl}/all`,
			'getAllRestitutionPrestation'
		);
	}

	importRestitutionPrestation(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'restitutionPrestation.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.restitutionPrestationUrl}/import`,
			`importRestitutionPrestation`,
			formData
		);
	}

	getRestitutionPrestationById(id: number): Observable<RestitutionPrestation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.restitutionPrestationUrl}/get/${id}`,
			'getRestitutionPrestationById'
		);
	}

	getByPrestation(prestationId: number): Observable<RestitutionPrestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.restitutionPrestationUrl}/getByPrestation/${prestationId}`,
			'getRestitutionPrestationById'
		);
	}

	updateRestitutionPrestation(restitutionPrestation: RestitutionPrestation): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.restitutionPrestationUrl}/update/${restitutionPrestation.id}`,
			'updateRestitutionPrestation',
			restitutionPrestation
		);
	}

	addRestitutionPrestation(restitutionPrestation: RestitutionPrestation): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.restitutionPrestationUrl}/add`,
			'addRestitutionPrestation',
			restitutionPrestation
		);
	}

	deleteRestitutionPrestation(restitutionPrestationId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.restitutionPrestationUrl}/delete/${restitutionPrestationId}`,
			`deleteRestitutionPrestation`
		);
	}
}
